// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3232":"6adee301","3606":"6adee301","6073":"6e40ec76"}[chunkId] + ".chunk.css";
};